module.exports = __webpack_public_path__ + "static/media/3_r_molbert_82.08_57.69.d5172175.png";